export const steps = [
  'dist_proposal_sumary',
  'dist_scope_registration',
  'dist_attachments',
  'dist_final'
];
